import { IconsEnum } from '../../../../../assets/icons/types';
import { ClassName, I18nText } from '../../../../../types';
import {
  OperationClientID,
  FetchOperationsCacheKey
} from '../../../operationsTypes';

import { useToastNotification } from '../../../../../common/hooks/useToastNotification';
import { useDutyForm } from '../../forms/DutyForm/hooks/useDutyForm';

import { DutyForm } from '../../forms/DutyForm';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { FormModalButton } from '../../../../../helpers/buttons/FormModalButton';

import { operationsKeys } from '../../../../../locales/keys';

const DUTY_FORM = 'duty-form';
const DUTY_BUTTON = 'duty-button';

interface CreateDutyOperationModalButtonProps {
  clientId: OperationClientID;
  cacheKeys?: FetchOperationsCacheKey[];
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  withToastOnSuccess?: boolean;
  disabled?: boolean;
}

function CreateDutyOperationModalButton({
  clientId,
  cacheKeys,
  className,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  withToastOnSuccess,
  disabled
}: CreateDutyOperationModalButtonProps) {
  const { showToastI18nNotification } = useToastNotification({
    appearance: 'success',
    i18nMessage: operationsKeys.recordAdded
  });

  const {
    validationErrors,
    registerFields,
    handleLeaveOfAbsence,
    resetDutyForm,
    createOperationReset,
    createOperationLoading,
    createOperationErrorMessage,
    control
  } = useDutyForm({
    cacheKeys,
    clientId,
    onSuccess: withToastOnSuccess ? showToastI18nNotification : undefined
  });

  return (
    <FormModalButton
      className={className}
      form={DUTY_FORM}
      dataGa={DUTY_BUTTON}
      i18nTitle={operationsKeys.duty}
      i18nText={i18nText}
      i18nTextClassName={i18nTextClassName}
      i18nSubmitText={operationsKeys.addRecord}
      icon={icon}
      iconClassName={iconClassName}
      onOpen={resetDutyForm}
      isLoading={createOperationLoading}
      onClose={createOperationReset}
      onSubmit={handleLeaveOfAbsence}
      disabled={disabled}
    >
      <DutyForm
        form={DUTY_FORM}
        isLoading={createOperationLoading}
        control={control}
        registerSubject={registerFields.registerSubject}
        subjectValidationError={validationErrors.subjectValidationError}
        dateValidationError={validationErrors.dateValidationError}
        completeDatetimeValidationError={
          validationErrors.completeDatetimeValidationError
        }
      />

      <div className="px-4">
        <AlertMessage message={createOperationErrorMessage} />
      </div>
    </FormModalButton>
  );
}

export default CreateDutyOperationModalButton;
